import {v4 as uuidv4} from 'uuid';
import {SET_UUID} from './actionTypes';
import { ADDRESS_FIELDS } from '../constants/serverFieldMappings';
import { fieldToReset, mergeWithSubmissionModel } from '../api/actionUtils';

export function refreshUUID() {
  return {type: SET_UUID, uuid: uuidv4()};
}

export function resetGoogleSpecifics(model="submission") {
  return dispatch => {
    [
      ADDRESS_FIELDS.GOOGLE_PLACE_ID,
      ADDRESS_FIELDS.LATITUDE,
      ADDRESS_FIELDS.LONGITUDE
    ].forEach(key => dispatch(fieldToReset({model, key})));
  };
}

export function setAccountAddress({
  model="submission",
  accountAddress,
  accountCoordinates
}) {
  const googleInfo = { ...accountAddress, ...accountCoordinates};

  return dispatch => mergeWithSubmissionModel({dispatch, googleInfo, model});
}

/**
 * sets address fields for owner at index with response data from Google Places API
 * @param {Number} ownerIndex
 * @param {Object} googleResponse
 */
export function setOwnerAddress(ownerIndex, {
  model="submission",
  accountAddress,
  accountCoordinates
}) {
  /**
  * googleInfo is an object of:
  * {address1, address2, city, zip, ...}
  * not all fields will be present
  */
  const googleInfo = { ...accountAddress, ...accountCoordinates };

  let updatedGoogleInfo = {};
  for (const key in googleInfo) {
    if (googleInfo.hasOwnProperty(key)) {
      let newKey = `owners[${ownerIndex}].${key}`;
      updatedGoogleInfo[newKey] = googleInfo[key];
    }
  }

  /**
  * `mergeWithSubmissionModel` will dispatch ReactReduxForm change action to all relative fields
  * and the field is formed by `${model}.${key}` where key is key in updatedGoogleInfo
  *
  * `mergeWithSubmissionModel` requires an obj argument with the following keys:
  *   - dispatch
  *   - googleInfo
  *   - model
  */
  return dispatch =>
    mergeWithSubmissionModel({
      dispatch,
      googleInfo: updatedGoogleInfo,
      model
    });
}